// import { Search } from '@/components/molecules/search';
import * as NavigationMenu from '@radix-ui/react-navigation-menu';

import { SecondaryNavButton } from '../secondary-navigation/components/SecondaryNavButton';
import { PrimaryNavigationProps } from './PrimaryNavigation.types';
import { Button, Icon, Logo } from '@goed/ui-components';
import { RoutesEnum } from '@goed-platform/shared/types';
import { useReactiveVar } from '@apollo/client';
import { isLoggedInVar, userInfoVar } from '@goed-platform/shared/data-access';
import { LanguageLink } from '../../../language-link';

export const PrimaryNavigation: React.FC<PrimaryNavigationProps> = ({
    onClickMobileTrigger,
    items: navItems,
}: PrimaryNavigationProps): JSX.Element => {
    const { items } = navItems;
    const isAuthenticated = useReactiveVar(isLoggedInVar);
    const userInfo = useReactiveVar(userInfoVar);

    return (
        <NavigationMenu.Root asChild>
            <div className="primary-nav">
                <div className="primary-nav__col primary-nav__col--left">
                    <button
                        onClick={onClickMobileTrigger}
                        className="primary-nav__mobile-button"
                        aria-label="mobile menu"
                    >
                        <Icon name="menu" />
                    </button>
                    <Logo variant="light" className="primary-nav__logo" modUld href="/" linkComponent={LanguageLink} />
                </div>
                <ul className="primary-nav__col primary-nav__uld">
                    {items.map((item, i) => (
                        <NavigationMenu.Item key={i} className="primary-nav__uld-item">
                            {'__typename' in item &&
                            (item.__typename === 'ExternalLinkRecord' || item.__typename === 'InternalLinkRecord') ? (
                                <SecondaryNavButton label={item?.label ?? ''} callToAction={item} />
                            ) : (
                                <>
                                    <SecondaryNavButton label={item?.title ?? ''} modExpendable />
                                    <NavigationMenu.Content
                                        onPointerMove={(event) => event.preventDefault()}
                                        onPointerLeave={(event) => event.preventDefault()}
                                        className="primary-nav__submenu"
                                    >
                                        <ul className="primary-nav__submenu-list">
                                            {item.links.map((link, i) => (
                                                <li key={i}>
                                                    <SecondaryNavButton
                                                        label={link.label ?? ''}
                                                        callToAction={link}
                                                        modLink
                                                    />
                                                </li>
                                            ))}
                                        </ul>
                                    </NavigationMenu.Content>
                                </>
                            )}
                        </NavigationMenu.Item>
                    ))}
                    <NavigationMenu.Item className="primary-nav__uld-item">
                        {isAuthenticated ? (
                            <>
                                <NavigationMenu.Trigger
                                    asChild
                                    onPointerMove={(event) => event.preventDefault()}
                                    onPointerLeave={(event) => event.preventDefault()}
                                >
                                    <Button variant="navigation" iconAfter="user">
                                        {userInfo?.firstName}
                                    </Button>
                                </NavigationMenu.Trigger>
                                <NavigationMenu.Content
                                    onPointerMove={(event) => event.preventDefault()}
                                    onPointerLeave={(event) => event.preventDefault()}
                                    className="primary-nav__submenu"
                                >
                                    <ul className="primary-nav__submenu-list">
                                        <li>
                                            <SecondaryNavButton
                                                label="mijn profiel"
                                                callToAction={{
                                                    __typename: 'ExternalLinkRecord',
                                                    openInNewWindow: true,
                                                    url: `${process.env.NEXT_PUBLIC_BASE_SHOP_URL}/nl/account`,
                                                }}
                                                modLink
                                            />
                                        </li>
                                        <li>
                                            <SecondaryNavButton label="uitloggen" modLink modLogout />
                                        </li>
                                    </ul>
                                </NavigationMenu.Content>
                            </>
                        ) : (
                            <Button
                                variant="navigation"
                                iconAfter="user"
                                href={RoutesEnum.login}
                                linkComponent={LanguageLink}
                            >
                                inloggen
                            </Button>
                        )}
                    </NavigationMenu.Item>
                </ul>
            </div>
        </NavigationMenu.Root>
    );
};
